import { createSlice } from "@reduxjs/toolkit";
import { fetchAppointmentByDateStatus } from "../../Thunk/Appointment/Api_Services/getAppointmentByDateStatus";

export interface Appointment {
    service_name: string;
    location: string;
    patient_name: string;
    status: string;
    provider_id: string;
    provider_email: string;
    provider_profile_image_path: string;
    to_date_time: string;
    from_date_time: string;
    service_id: string;
    patient_email: string;
    patient_dob: string;
    notes: string;
    event_id: string;
    patient_profile_image_path: string;
    provider_name: string;
    patient_id: string;
  }
export interface AppState {
    RequestedData: Appointment[];
    isLoading: boolean;
    error: string | null | undefined;
}

const initialState: AppState = {
    RequestedData: [],
    isLoading: false,
    error: null,
};

const AppointmentByDateStatusSlice = createSlice({
    name: "AppointmentByDateStatus",
    initialState,
    reducers: {
        // Your other reducers go here
        resetState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAppointmentByDateStatus.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchAppointmentByDateStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.RequestedData = action.payload;
            })
            .addCase(fetchAppointmentByDateStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export default AppointmentByDateStatusSlice;